module.exports = __webpack_public_path__ + "static/media/create-teams-screenshot.b4ae0a4c.svg";